import styled, { keyframes } from "styled-components"
import { tabletSize, mobileSize, userSelect, colors } from "../../constants"

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
`

export const LoadingBg = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const rotateForever = keyframes`
0% { transform:rotate(0deg) }
100% { transform:rotate(360deg) }
`

export const LoadingItem = styled.div`
  position: absolute;
  top: calc(50% - 23px);
  left: calc(50% - 23px);
  height: 30px;
  width: 30px;
  border: 8px solid ${colors.blood_orange};
  border-right-color: transparent;
  border-radius: 50%;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-name: ${rotateForever};
  animation-timing-function: linear;
  size: 30px;
`
